define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action",
	"csi/heading/BooleanController",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,_,csiAction,BooleanController,MessageDialog,xml) {

	return declare(BooleanController, {
		// Boolean: publish request immediately
		bHold: false,
		
		// Boolean: indicates if confirming action
		_bConfirm: false,
		
		confirmAction: function(/*Object*/params) {
			//summary: customize buttons
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.buttons = [MessageDialog.BUTTON_MAKE_ACTIVE + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_EDIT_SIZE_MAP, MessageDialog.BUTTON_CANCEL];
			this.inherited(arguments);
		},
					
		onConfirm: function(/*String*/key) {
			// summary: action failed if user did not force action
			if (key == MessageDialog.BUTTON_MAKE_ACTIVE) {
				this.process();
			} else if (key == MessageDialog.BUTTON_EDIT_SIZE_MAP){
				this.postProcess();
				var self = this;
				_.delay(function(){
						csiAction.invoke(self.widget,self.refNode,"EditMapping",null,null);
					}, 1);
			} else {
				this._refresh(false);
				this.postProcess();
			}
		},
		
		toWriterRequest: function() {
			var	call = this.inherited(arguments);
			
			if (this._bConfirm) {
				call.addParameter("Force", xml.ATTR_BOOLEAN, true);
			}
			
			return call;
		},

		postProcess: function(/*Boolean*/bStatus) {
			// summary: if error code signals incomplete size map, then prompt if they want to force active
			if (this._errorCode == "SRV_ERR_ProductSpec_SIZE_MAP_INCOMPLETE") {
				this._bConfirm = true;
				this._errorCode = null;
				this.confirmAction({});
			} else {
				this.inherited(arguments);
			}
		}
	});
});